export default "__VITE_ASSET__BCSp5P2C__"